<app-modal-wrapper ariaRole="dialog" [ariaLabelledBy]="ariaLabelledBy()" [ariaDescribedBy]="undefined" [title]="modalTitle()">
  <div class="modal-body">
    <div class="modal-body__info">
      <ng-content select="[entityInfo]"></ng-content>
    </div>

    @if (dataLoading()) {
      <app-loading-animation></app-loading-animation>
    }

    @if (dataAvailable()) {
      <div class="modal-body__content">
        <app-table-template tableTitle="Transactions"
          [showTitle]="false"
          [showSearch]="true"
          [showToggle]="false"
          [hasCardView]="false"
          [showPagination]="true"
          [clickableRows]="false"
          [columns]="columns()"
          [currentPage]="currentPage()"
          [sortedOn]="sortField()"
          [sortDescending]="sortOrder() === -1"
          [tableMinWidthInRem]="tableMinWidthInRem()"
          (sortChanged)="onSort($event)"
          (searchChanged)="onSearch($event)"
          (pageChanged)="onPage($event)">
        </app-table-template>
      </div>
    }

    @if (dataEmpty()) {
      <div class="modal-body__empty">{{emptyMessage()}}</div>
    }
  </div>
</app-modal-wrapper>
